export const notificationCloseTimeout = 6000; // 6000 ms to auto-close notifications
